
 <body>
    <app-account-header [userNamechangeData]="userNamechangeval"></app-account-header>
  <div class="clear20"></div>
<div class="row mt-5 p-5">
    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
        <div class="row">
        <div class="circle cp">
        <img src="./assets/images/backarrow.png" class="mt-2 outline-0" routerLink="/dashboard" >
        </div>
        <div class="pl-2 mt-1">
        <span class="semi-bold fs-20 txt-lightblack2 ">Your Account</span>
        </div>    
      </div>
      <div class="clear30"></div>

        <div class="card edit-card">
            <div class="card-body">
                <div class="row ">
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                        <h6 class="regular txt-lightgrey mb-1">Your Full Name</h6>
                        <h6 class="semi-bold txt-lightblack1">{{name}} {{name1}}</h6>
                        <!-- <h6 class="semi-bold txt-lightblack1">{{firstName}} {{lastName}}</h6> -->
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <button type="button" class="btn edit-btn" (click)="editNameModal = !editNameModal"><img src="./assets/images/pencilicon.png" class="pr-2" />Edit</button>
                    </div>
                </div>     
                <div class="clear5"></div>  
                <hr/> 
                <div class="clear5"></div>  
                <div class="row ">
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                        <h6 class="regular txt-lightgrey mb-1">Registered Email ID</h6>
                        <h6 class="semi-bold txt-lightblack1">{{userEmail}}</h6>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <button type="button" class="btn editdisabled" (click)="editEmailModal = !editEmailModal" disabled><img src="./assets/images/pencilicon.png" class="pr-2" /> Edit</button>
                    </div>
                </div>     
                <div class="clear5"></div>  
                <hr/> 
                <div class="clear5"></div>  
                <div class="row ">
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12">
                        <h6 class="regular txt-lightgrey mb-1">Registered Phone No</h6>
                        <h6 class="semi-bold txt-lightblack1">{{userPhone}}</h6>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                        <button type="button" class="btn edit-btn" (click)="editphoneModal = !editphoneModal"><img src="./assets/images/pencilicon.png" class="pr-2" /> Edit</button>
                    </div>
                </div>     
                <div class="clear5"></div>  
              
            </div>
        </div>    
        <div class="clear20"></div>
        <h6 class="semi-bold txt-blue3 underline cp outline-0" routerLink="/change-password">Change Password</h6>
    </div>        
</div>    
</body>  


<!-- Edit Name Modal start -->
<div class="modal" id="editNameModal" [style.display]="editNameModal ? 'block' : 'none'">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content modal-card">
        <div class="modal-header border-0">
            <h6 class="fs-23 semi-bold text23">Edit Name</h6>

          <img class="close cp" src="./assets/images/close.png" (click)="editNameModal = !editNameModal">
        </div>
        <!-- Modal body -->
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-3">
                    <div class="form-group">
                        <label class="fs-14 semi-bold txt-lightblack2">First Name</label>
                        
                        <input type="text" (input)="fn()" class="form-control {{ErrorMsgthree?'borderb-red':''}}" [(ngModel)]="firstName" placeholder="First Name">
                        <span class="error-msg red fs-14" *ngIf="ErrorMsgthree">First Name is required</span>

                    </div>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12 pr-3">
                    <div class="form-group">
                        <label class="fs-14 semi-bold txt-lightblack2">Middle Name</label>
                        <input type="text" class="form-control forminput" [(ngModel)]="middleName" name="middleName" placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-12">
                    <div class="form-group">
                        <label class="fs-14 semi-bold txt-lightblack2">Last Name</label>
                        <input type="text" (input)="ln()" placeholder="Last Name" [(ngModel)]="lastName" class="form-control {{ErrorMsgtwo?'borderb-red':''}}">
                        <span class="error-msg red fs-14" *ngIf="showemailErrorMsg">Last Name is required</span>                        
                    </div>
                </div>    
            </div>    
            <div class="clear20"></div>
            <button type="button" class="btn update-btn" (click)="updateName()">Update Name</button>

        </div>
      </div>
    </div>
  </div>
<!-- Edit Name Modal End -->


<!-- Edit Email Modal start -->
<div class="modal" id="editEmailModal" [style.display]="editEmailModal ? 'block' : 'none'">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-card">
        <div class="modal-header border-0">
            <h6 class="fs-23 semi-bold text23">Edit Email</h6>

          <img class="close cp" src="./assets/images/close.png" (click)="editEmailModal = !editEmailModal">
        </div>
        <!-- Modal body -->
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 pr-3">
                    <div class="form-group">
                        <label class="fs-14 semi-bold txt-lightblack2">Email Address</label>
                        <input type="email" class="form-control {{showemailErrorMsg?'borderb-red':''}}" placeholder="example@gmail.com" autocomplete="off" [(ngModel)]="email" (keyup)="ValidateEmail(email)" (input)="emailErrorMsg()">
                        <!-- <input type="email" class="instyle regular w-100 olnone" placeholder="example@example.com"> -->
                        <span class="error-msg red fs-14" *ngIf="showemailErrorMsg">Please enter valid email</span>

                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                    <div class="form-group">
                        <label class="fs-14 semi-bold txt-lightblack2">Confirm Email</label>
                        <!-- <input type="text" class="form-control forminput" placeholder="example@gmail.com"> -->
                        <input type="email" class="form-control {{showemailErrorMsgone?'borderb-red':''}}" placeholder="example@gmail.com" autocomplete="off" [(ngModel)]="gemail" (keyup)="ValidateEmailone(gemail)" (input)="emailErrorMsgone()">
                        <span class="error-msg red fs-14" *ngIf="showemailErrorMsgone">Please enter confirm email</span>
                    </div>
                </div>              
            </div>    
            <div class="clear20"></div>
            <button type="button" class="btn update-btn" (click)="updateemail()">Send Verification Link</button>

        </div>
      </div>
    </div>
  </div>
<!-- Edit Email Modal End -->


<!-- Edit Phone Number Modal start -->
<div class="modal" id="editphoneModal" [style.display]="editphoneModal ? 'block' : 'none'">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-card">
        <div class="modal-header border-0">
            <h6 class="fs-23 semi-bold text23">Edit Phone No</h6>

          <img class="close cp" src="./assets/images/close.png" (click)="editphoneModal = !editphoneModal">
        </div>
        <!-- Modal body -->
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 ">
                    <div class="form-group">
                        <label class="fs-14 semi-bold txt-lightblack2">Phone Number</label>
                        <!-- <input type="number" class="form-control {{ErrorMsgfour?'borderb-red':''}}" placeholder="8888888888" maxlength="10" minlength="10" [(ngModel)]="phoneNumber">
                        <span class="error-msg red fs-14" *ngIf="ErrorMsgfour">Enter valid phone number</span>                         -->
                        <input type="tel" onkeydown="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^[0-9()\-]+$]*/g,'');" [(ngModel)]="phoneNumber" (change)="checkPhone()" class="form-control {{ErrorMsgfour?'borderb-red':''}}" placeholder="+1 250-555-0199" maxlength="15" >
    <span class="error-msg red fs-14" *ngIf="ErrorMsgfour" style="color: red;" >
      {{error1}}
    </span>
                    </div>
                </div>
          
              
            </div>    
            <div class="clear20"></div>
            <button type="button" class="btn update-btn" (click)="updatePhno()">Update Phone No</button>

        </div>
      </div>
    </div>
  </div>
<!-- Edit Phone Number Modal End -->
<!-- <div class="boxstyle">
    <label class="txtblack fs-20 semi-bold"><img class="cp" src="./assets/images/backarrow.png"routerLink="/activated"></label>

<div>
    <ul>
        <li class="{{tabs[0].active}}" (click)="openTabs(0)"><a class="active">Personal Info</a></li>
        <li class="{{tabs[1].active}}" (click)="openTabs(1)"><a>Documents & Agreement</a></li>
        <li class="{{tabs[2].active}}" (click)="openTabs(2)"><a>Change password</a></li>
    </ul>
   
</div>
<div class="row {{tabs[0].tabcontent}}" *ngIf="tabs[0].active">
    
    <div class="col-sm-4 col-md-3 col-lg-3 col-12 ml-auto">
        <div class="clear20"></div>

        <button type="button" class="btn btn-blue" *ngIf="showEdit" (click)="Edit()">Edit</button>
        <button type="button" class="btn btn-dblue ml-3" *ngIf="showSave == true"> Update</button>
        <button type="button" class="btn cancalbtn" *ngIf="showSave">Cancel</button>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12"*ngIf="showEdit">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 fullheight  mt-70">
                <div class="main-content">
                    <div class="clear50"></div>
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Salutation</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                       
                                    </div>
                           
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">First Name:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Middle Name:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Last Name:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>    
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Proficient Languages:</label>
    
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Agency/MGA:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Position Title:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Work Phone:</label>
                                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 p-0">
                                    </div>
                                    <label class="mb-2 mr-1 regular fs-14 txt-lightblack2">EXT&nbsp;&nbsp;</label>
                                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 p-0">
    
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Mobile Number:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 p-0 Tab">
                                   
                                    </div>
    
                                </div>
    
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">
                                        <label class="mb-2 regular fs-14 txt-lightblack2 ">Email Address:</label>
                                        <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 p-0 Tab">
                                   
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Website:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Products Selling:</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                    </div>
                                </div>
                            </div>
      
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Primary Street Address:</label>
                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">Primary Address City:</label>
                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">Primary Province:</label>
                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12  mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Provinces Licensed:</label>
    
                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12 p-0 Tab ">
                                   
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Primary Postal Code:</label>
                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                          
    
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">Alternative Street Address:</label>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                        </div>
                                    </div>
                                </div>
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">Alternative Address City:</label>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                        </div>
                                    </div>
                                </div>
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
    
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">Alternative Province:</label>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                        </div>
                                    </div>
                                </div>
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 text-right">Alternative Postal Code:</label>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                        </div>
    
                                    </div>
                                </div>
                                
                            
                             
                            </div>
                         
                            <div class="clear20"></div>
    
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Tags:</label>
                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    </div>
                                </div>
                            </div>
    
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">CIPR Number:</label>
                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-12">
                                    </div>
                                </div>
                            </div>
                        </div>
    
                    </div>
                   
                </div>

    
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="showSave">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 fullheight  mt-70">
                <div class="main-content">
                    <div class="clear50"></div>
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Salutation</label>
                                    <div class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                        <select class="form-control forminput Tab">
                                            <option>Select</option>
                                            <option>1</option>
                                            <option>2</option>
                                        </select>
                                    </div>
                           
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">First Name</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="First Name">
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Middle Name</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="First Name">
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Last Name</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Last Name">
                                </div>
                            </div>
    
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Proficient Languages</label>
                                    <select class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                        <option>Select</option>
                                        <option>1</option>
                                        <option>2</option>
                                    </select>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Agency/MGA</label>
                                    <select class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                        <option>Select</option>
                                        <option>1</option>
                                        <option>2</option>
                                    </select>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Position Title</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Position Title">
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Work Phone</label>
                                    <input type="text" class="form-control forminput col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 Tab" placeholder="+1250-555-5555">

                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2">&nbsp;&nbsp;&nbsp;EXT&nbsp;&nbsp;&nbsp;</label>
                                    <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 p-0">
                                        <input type="text" class="form-control forminput Tab">
                                    </div>
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Mobile Number</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Mobile Number">
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Email Address</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Email Address">
                                </div>
    
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Website</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Website">
                                </div>
                            </div>
                            <div class="clear20"></div>
      
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Primary Street Address</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Primary Street Address">
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 col-12 text-right">Primary Address City</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Primary Address City">
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Primary Province</label>
                                    <select class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                        <option>Select</option>
                                        <option>1</option>
                                        <option>2</option>
                                    </select>
                                </div>
                            </div>
                            <div class="clear20"></div>
                           
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Primary Postal Code</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Primary Postal Code">
                                </div>
                            </div>
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12  mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">Provinces Licensed</label>
                                    <select class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab">
                                        <option>Select</option>
                                        <option>1</option>
                                        <option>2</option>
                                    </select>                                
                                </div>
                            </div>
                            
                            <div class="clear20"></div>
                          
    
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Alternative Street Address</label>
                                        <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Alternative Street Address">

                                    </div>
                                </div>
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Alternative Address City</label>
                                        <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Alternative Address City">

                                    </div>
                                </div>
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
    
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Alternative Province</label>
                                        <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Alternative Province">
                                    </div>
                                </div>
                                <div class="clear20"></div>
                                <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                    <div class="form-row">
                                        <label class="mb-2 mr-3 regular fs-14 txt-lightblack2 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 text-right">Alternative Postal Code</label>
                                        <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="Alternative Postal Code">

    
                                    </div>
                                </div>
                            </div>
                         
    
    
                            <div class="clear20"></div>
                            <div class="col-sm-6 col-md-12 col-lg-12 col-xl-12 col-12 ">
                                <div class="form-row">
                                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12 mb-2 mr-3 regular fs-14 txt-lightblack2 text-right">CIPR Number</label>
                                    <input type="text" class="form-control forminput col-sm-7 col-md-7 col-lg-7 col-xl-7 col-12 Tab" placeholder="CIPR Number">
                                    <img src="./assets/images/info.png" class="infopos cp" />
                                </div>
                            </div>
                        </div>
    
                    </div>
                   
                </div>

    
            </div>
        </div>
    </div>

</div>
<div class="row {{tabs[1].tabcontent}}" *ngIf="tabs[1].active">

    <div class="row greystrip">
        <div class="col-sm-12 col-md-12 col-lg-12 col-12">
            <h5 class="semi-bold text46 pl-2 ">Documents</h5>
        </div>

    </div>
    <label class="fbold fs-18 txt39"style= " margin-top: 35px;margin-left: -105px;">E & O</label>
    <div class="table-responsive">
        <table class="table bg-white">
            <thead>
                <tr>
                    <th class="semi-bold fs-14 text46 w150">Document Name</th>
                    <th class="semi-bold fs-14 text46 w150">E & O Number</th>
                    <th class="semi-bold fs-14 text46 w150">Uploaded Date</th>
                    <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
            
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td class="fs-14 regular dgrey"></td>
                    <td class="fs-14 regular dgrey"></td>
                    <td class="fs-14 regular dgrey"></td>
                    
                </tr>
            </tbody>
        </table>
    </div>
    <div class="clear10"></div>
    <label class="fbold fs-18 txt39">License</label>
    <div class="table-responsive">
        <table class="table bg-white">
            <thead>
                <tr>
                    <th class="semi-bold fs-14 text46 w150">Document Name</th>
                    <th class="semi-bold fs-14 text46 w150">License Type</th>
                    <th class="semi-bold fs-14 text46 w150">License Number</th>
                    <th class="semi-bold fs-14 text46 w150">Expiry Date</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td class="fs-14 regular dgrey"></td>
                    <td class="fs-14 regular dgrey"></td>
                    <td class="fs-14 regular dgrey"></td>
                
                </tr>
            </tbody>
        </table>
    </div>
    <div class="clear20"></div>
    <label class="fbold fs-18 txt39">Void Cheque</label>
    <div class="table-responsive">
        <table class="table bg-white">
            <thead>
                <tr>
                    <th class="semi-bold fs-14 text46 w150">Document Name</th>
           
                    <th class="semi-bold fs-14 text46 w150">Upload Void Cheque</th>
                </tr>
            </thead>
            <tbody>
                <tr >
                    <td></td>

                    <td><u>Edit</u></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row greystrip">
        <div class="col-sm-12 col-md-12 col-lg-12 col-12">
            <h5 class="semi-bold text46 pl-2 mt-1">Agreement</h5>
        </div>

    </div>
    <div class="clear20"></div>
   
    <div class="table-responsive">
        <table class="table bg-white">
            <thead>
                <tr>
                    <th class="semi-bold fs-14 text46">Agreement Name</th>
                    <th class="semi-bold fs-14 text46">Created On</th>
                    <th class="semi-bold fs-14 text46">Signed On</th>
                    <th class="semi-bold fs-14 text46">Compliance Status</th>
                    <th class="semi-bold fs-14 text46">Broker Status</th>
                    <th class="semi-bold fs-14 text46">Status</th>

                </tr>
            </thead>
            <tbody>
                <tr >
                    <td></td>

                    <td class="fs-14 regular dgrey"></td>
                    <td class="fs-14 regular dgrey"></td>
                    <td class="fs-14 regular dgrey"></td>
                    <td class="fs-14 regular dgrey"></td>

                    <td class="fs-14 regular dorange"></td>
                </tr>


            </tbody>
        </table>
    </div>
</div>
<div class="row {{tabs[2].tabcontent}}" *ngIf="tabs[2].active">
    
    <div class="d-flex align-items-center auth w50 px-0">
        <div class="row w-100  mx-0 mt-3">
          <div class="col-lg-12 mx-auto">
            <label class="txtblack fs-20 semi-bold">Change Password</label>
            <div class="clear5"></div>
            <div class="auth-form-light bg-white">
    <form >
        <h6 class="fs-16 txtblack semi-bold mb-3">Enter Current Password</h6> 
        <div class="form-group">
          <input type=""  class="form-control forminput " placeholder="" autocomplete="off">
          
      
          <span class="error-msg">Please Enter Current Password</span>

        </div>

       
        <div class="clear5"></div>

        <h6 class="fs-16 txtblack semi-bold mb-3">Enter New Password</h6> 
        <div class="form-group m-0 password-input">
          <div>
          <input type=""  class="form-control forminput" placeholder="" autocomplete="off">
          <img src="./assets/images/eye.png" class="cp password-img img-responsive cp">
        </div>
          <span class="error-msg" >Please Enter New Password</span>
        </div>
        

        <h6 class="fs-16 txtblack semi-bold mb-3">Confirm New Password</h6> 
        <div class="form-group">
          <input type=""  class="form-control forminput"  placeholder="" autocomplete="off">
      
          <span class="error-msg" >Please Enter Confirm Password</span>

        </div>
    

        <div class="mt-3">
          <div class="row">
            
         
              <div class="col-sm-8 col-md-8">
                <div class="clear10"></div>
                <a class="btn btn-block blue-btn semi-bold fs-16">UPDATE PASSWORD</a>
               
              </div>
         </div>
        </div>
      </form>
    </div>
</div>
</div>
</div>
</div>

</div> -->